// noinspection JSUnusedGlobalSymbols

import GetListQuery from "./GetListQuery";
import Api from "../Api";
import HttpClient from "../HttpClient";
import Page from "../Page";
import VCard from "./VCard";
import CreatePayload from "./CreatePayload";
import UpdatePayload from "./UpdatePayload";

class VCardApi {
    /**
     * @author Kacper Faber
     * @since 0.1.6
     * @param query
     */
    static getList(query: GetListQuery): Promise<Page<VCard>> {
        const url = Api.getUrl('/api/vcard/');
        return HttpClient.get<Page<VCard>>(url, { ...query });
    }

    /**
     * Update VCard.
     * @author Kacper Faber
     * @since 0.2.0
     */
    static updateById(id: number | string, payload: UpdatePayload): Promise<any> {
        const url = Api.getUrl(`/api/vcard/${id}/`);
        return HttpClient.put<any>(url, {}, { ...payload });
    }

    /**
     * Get VCard by ID.
     * Use then/catch.
     * @author Kacper Faber
     * @since 0.1.6
     * @param id
     */
    static getById(id: number): Promise<Page<VCard>> {
        const url = Api.getUrl(`/api/vcard/${id}/`);
        return HttpClient.get(url, {});
    }

    static deleteById(id: number): Promise<void> {
        const url = Api.getUrl(`/api/vcard/${id}/`);
        return HttpClient.execNoContent(url, 'DELETE', {}, {});
    }

    static delete(e: VCard): Promise<void> {
        const url = Api.getUrl(`/api/vcard/${e.id}/`);
        return HttpClient.execNoContent(url, 'DELETE', {}, {});
    }

    /**
     * Create new VCard.
     * @returns VCard
     * @param p
     */
    static create(p: CreatePayload): Promise<VCard> {
        const url = Api.getUrl(`/api/vcard/`);
        return HttpClient.post(url, {}, { ...p });
    }
}

export default VCardApi;